import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import SaporeForm from "../../../forms/SaporeForm";
import EmailField from "../../../forms/fields/EmailField";
import {USER_PATH} from "../../../routes";
import successToast from "../../../components/toast/SuccessToast";
import errorToast from "../../../components/toast/ErrorToast";


export default class CreateUserFeature {
    constructor(application, navigator) {
        this._application = application;
        this._navigator = navigator;
        this._loaded = false;
        this._form = null;

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
            form: computed,
            _form: observable,
            isFormValid: computed,
            _finishLoading: action
        })
    }

    async load() {
        this._createForm()
        this._finishLoading()
    }

    _createForm() {
        const fields = {
            "email": new EmailField(true),
        }
        this.form = new SaporeForm(fields);
    }

    async createUser() {
        const user = this.userForm().values;
        const responseHandler = new ApiResponseHandler({

            handlesSuccess: async (response) => {
                const authMethodResponse = await this._application.apiClient().createUserOnAuthenticationMethod(user.email)
                if (!authMethodResponse.hasErrors()) {
                    const email = response.userEmail()
                    window.open(this.userPath() + `/${email}`)
                    successToast("El usuario fue creado con éxito.")
                } else {
                    this.showAlert(authMethodResponse.errorMessage())
                }
            },
            handlesError: (response) => {
                response.errors().map(error => {
                    this.showAlert(error);
                })
            }
        });
        return this.createUserWithApiClient(user, responseHandler);
    }

    createUserWithApiClient(user, responseHandler) {
        return this._application.apiClient().createUser(user, responseHandler);
    }

    userForm() {
        return this.form;
    }

    get isFormValid() {
        return this.userForm().isValid;
    }

    get form() {
        return this._form;
    }

    set form(newForm) {
        this._form = newForm;
    }

    get loaded() {
        return this._loaded;
    }

    userPath(){
        return USER_PATH
    }

    _finishLoading() {
        this._loaded = true;
    }

    showAlert(error) {
        if (error.code === 'duplicated_user') {
            errorToast('Ya existe un usuario para este email.')
        } else {
            errorToast("No se pudo crear el usuario.")
        }
    }
}